function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M33.192 14.808a2 2 0 010 2.828L26.828 24l6.364 6.364a2 2 0 11-2.828 2.828L24 26.828l-6.364 6.364a2 2 0 11-2.828-2.828L21.172 24l-6.364-6.364a2 2 0 112.828-2.828L24 21.172l6.364-6.364a2 2 0 012.828 0z",
  fill: "currentColor",
  fillRule: "evenodd"
});

var SvgHuge = function SvgHuge(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 48,
      height: 48
    }, props), _ref)
  );
};

export default SvgHuge;